// Lib
import { forwardRef } from "react";
import { ControllerFieldState } from "react-hook-form";
import { InputProps as AntInputProps, InputRef } from "antd";
// Styles
import { Typography } from "styled/Typography";
import { ErrorMessage, InputFieldPassword } from "../styled";
import { InvisibleIcon, VisibleIcon } from "./styled";

interface InputProps extends AntInputProps {
  label?: string;
  fieldState?: ControllerFieldState;
  fieldError?: boolean | string;
}

export const PasswordInput = forwardRef<InputRef, InputProps>(
  ({ label, fieldError, fieldState, ...props }, ref) => {
    const error = fieldError || fieldState.error?.message || false;

    return (
      <div>
        {!!label && <Typography.Label>{label}</Typography.Label>}

        <InputFieldPassword
          ref={ref}
          {...props}
          status={!!error && "error"}
          iconRender={visible =>
            visible ? <VisibleIcon /> : <InvisibleIcon />
          }
        />

        {!!error && <ErrorMessage>{error}</ErrorMessage>}
      </div>
    );
  },
);

PasswordInput.displayName = "PasswordInput";
